import { mobileCombustionInputsUK } from './regions/UK-mobile-combustion.input'
import { mobileCombustionInputsUS } from './regions/US-mobile-combustion.input'

export const mobileCombustionMapping: { [key: string]: any } = {
  US: mobileCombustionInputsUS,
  UK: mobileCombustionInputsUK,
}
